import firebase from 'firebase'
import firestore from 'firebase/firestore'

var firebaseConfig = {
    apiKey: "AIzaSyCUfUEblHAU1NFtPvGmBzSQOUY3Z9NfWJI",
    authDomain: "meow-chat-1dfe0.firebaseapp.com",
    databaseURL: "https://meow-chat-1dfe0.firebaseio.com",
    projectId: "meow-chat-1dfe0",
    storageBucket: "",
    messagingSenderId: "575469233339",
    appId: "1:575469233339:web:b918df10ad9c82f0"
  };
  
  // Initialize Firebase
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  export default firebaseApp.firestore() 


// WEBPACK FOOTER //
// ./src/firebase/init.js